var map = {
	"./bg-exclusive.webp": 1348,
	"./border-bg-sm.png": 1349,
	"./border-bg-xm.png": 1350,
	"./border-bg.png": 1351,
	"./btn-active.png": 1352,
	"./casino-hover.webp": 1353,
	"./cny-flower-1.webp": 1354,
	"./cny-flower-2.webp": 1355,
	"./cny-mobile-bg.webp": 1356,
	"./content-deco-1.webp": 1357,
	"./content-deco-2.webp": 1358,
	"./content-deco-3.webp": 1359,
	"./content-deco-4.webp": 1360,
	"./content-deco-5.webp": 1361,
	"./deposit-icon.webp": 1362,
	"./event-border-hover.webp": 1363,
	"./games-hover.webp": 1364,
	"./home-icon-active.webp": 1365,
	"./home-icon.webp": 1366,
	"./live-icon-active.webp": 1367,
	"./live-icon.webp": 1368,
	"./lottery-hover.webp": 1369,
	"./master-bg.png": 1370,
	"./me-icon-active.webp": 1371,
	"./me-icon.webp": 1372,
	"./p2p-hover.webp": 1373,
	"./platform.webp": 1374,
	"./product-overview-bg.webp": 1375,
	"./promos-icon-active.webp": 1376,
	"./promos-icon.webp": 1377,
	"./slots-hover.webp": 1378,
	"./sponsor-icon-active.webp": 1379,
	"./sponsor-icon.webp": 1380,
	"./sports-hover.webp": 1381,
	"./title-deco-bg.webp": 1382,
	"./title-deco-left.webp": 1383,
	"./title-deco-right.webp": 1384,
	"./vip-icon-active.webp": 1385,
	"./vip-icon.webp": 1386,
	"./withdraw-icon.webp": 1387,
	"./wwr-bg.webp": 1388,
	"./wwr-img.webp": 1389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;